import { Locale, loc_theresAProblem } from '@cumu/strings';
import { html } from '../template';
import { newElementId } from './element-id';

export function errorAlertTemplate(
  locale: Locale,
  alertId = newElementId(),
  classes = 'span-12 width-full'
) {
  const headingId = newElementId();
  // note: getErrorAlert looks for flash with ul as last child
  return html`<div
    class="flash flash-error py-2 ${classes}"
    id="${alertId}"
    role="group"
    tabindex="-1"
    aria-labelledby="${headingId}"
    hidden
  >
    <h2 style="font-size: 1em;" id="${headingId}">
      ${loc_theresAProblem[locale]}
    </h2>
    <ul class="pl-3"></ul>
  </div>`;
}
